import { DatePicker } from '@/components/ui/date-picker.tsx';
import { Label } from '@/components/ui/label.tsx';

interface DateFieldProps {
  label: string;
  id: string;
  value: string;
  onChange: (value: string) => void;
  min?: string;
  max?: string;
  disabled?: boolean;
}

export function DateField({ label, id, value, onChange, min, max, disabled }: DateFieldProps) {
  return (
    <div className="flex min-w-[min(100%,12rem)] flex-1 flex-col gap-1">
      <Label htmlFor={id}>{label}</Label>
      <DatePicker
        id={id}
        value={value}
        onChange={onChange}
        min={min}
        max={max}
        disabled={disabled}
      />
    </div>
  );
}
